const links = [
  {
    title: "Motorisation Somfy",
    desc: "Pose de motorisation Somfy sur volet existant ou neuf : moteur, commandes et automatismes.",
    href: "/motorisation-somfy",
    icon: "ri-remote-control-line",
  },
  {
    title: "Moteur Somfy",
    desc: "Moteur Somfy en panne ? Remplacement rapide, diagnostic et reprogrammation des commandes.",
    href: "/moteur-somfy",
    icon: "ri-settings-3-line",
  },
  {
    title: "Dépannage urgence",
    desc: "Volet bloqué ou coincé en urgence ? Intervention rapide à Strasbourg et dans le Bas-Rhin.",
    href: "/depannage-urgence",
    icon: "ri-alarm-warning-line",
  },
];

export default function Maillage() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-3">
          Vous cherchez une autre prestation ?
        </h2>
        <p className="text-brand-text text-base text-center mb-10 md:mb-14 max-w-2xl mx-auto">
          Nous intervenons aussi sur ces services. Découvrez nos autres solutions pour votre volet roulant.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {links.map((link) => (
            <a
              key={link.title}
              href={link.href}
              className="group bg-white rounded-xl border border-brand-border p-5 md:p-6 hover:border-brand-cyan/40 transition-colors flex flex-col"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-brand-cyan/10 mb-4">
                <i className={`${link.icon} text-brand-cyan text-lg`}></i>
              </div>
              <h3 className="text-brand-blue text-base font-bold mb-2 group-hover:text-brand-cyan transition-colors">
                {link.title}
              </h3>
              <p className="text-brand-text text-sm leading-relaxed">{link.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}